import { IconCheck } from "../icon/variants/IconCheck.js";
import { Subtitle2 } from "../typography/Subtitle2.js";
import chip_module_default from "./chip.module.js";
import { Box, Chip, ChipGroup } from "@mantine/core";
import { forwardRef } from "react";
import { jsx } from "react/jsx-runtime";

//#region src/components/chip/Chip.tsx
const Chip$1 = (() => {
	const Component = forwardRef(({ children, checked, onChange, color = "primary", disabled, value, onClick, "data-testid": testId }, ref) => /* @__PURE__ */ jsx(Box, {
		ref,
		"data-testid": testId,
		children: /* @__PURE__ */ jsx(Chip, {
			checked,
			icon: /* @__PURE__ */ jsx(IconCheck, { color }),
			classNames: chip_module_default,
			onChange,
			color: disabled ? void 0 : color,
			variant: "light",
			disabled,
			radius: "xs",
			size: "md",
			value,
			onClick,
			children: /* @__PURE__ */ jsx(Subtitle2, {
				color,
				children
			})
		})
	}));
	Component.displayName = "Chip";
	const ChipComponent = Component;
	ChipComponent.Group = ChipGroup;
	return ChipComponent;
})();

//#endregion
export { Chip$1 as Chip };